module.exports = __webpack_public_path__ + "img/4.51871853.png";